export default __webpack_public_path__ + "static/media/B1.e94bee25.png";